"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var Typography_1 = require("@material-ui/core/Typography");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var React = require("react");
var config_1 = require("../../config");
var withStyles_1 = require("../../decorators/withStyles");
var styles = require("./style.css");
var FieldHtml = /** @class */ (function (_super) {
    tslib_1.__extends(FieldHtml, _super);
    function FieldHtml(props) {
        var _this = _super.call(this, props) || this;
        _this.textareaRef = React.createRef();
        _this.loadDependencies = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, loadLocale, loadPlugins, svgPath;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!window.jQuery) return [3 /*break*/, 2];
                        _a = window;
                        _b = window;
                        return [4 /*yield*/, Promise.resolve().then(function () { return require('jquery'); })];
                    case 1:
                        _a.jQuery = _b.$ = (_d.sent());
                        _d.label = 2;
                    case 2:
                        _c = config_1.getConfig().trumbowyg, loadLocale = _c.loadLocale, loadPlugins = _c.loadPlugins;
                        return [4 /*yield*/, Promise.all([
                                Promise.resolve().then(function () { return require('trumbowyg/dist/ui/icons.svg'); }),
                                Promise.resolve().then(function () { return require('trumbowyg/dist/trumbowyg.min.js'); }),
                                Promise.resolve().then(function () { return require('trumbowyg/dist/ui/trumbowyg.min.css'); }),
                            ])];
                    case 3:
                        svgPath = (_d.sent())[0];
                        return [4 /*yield*/, Promise.all([
                                Promise.resolve().then(function () { return require('trumbowyg/dist/plugins/history/trumbowyg.history.min.js'); }),
                                Promise.resolve().then(function () { return require('trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.min.js'); }),
                                loadLocale ? loadLocale() : Promise.resolve()
                            ].concat((loadPlugins ? loadPlugins() : [])))];
                    case 4:
                        _d.sent();
                        return [2 /*return*/, svgPath];
                }
            });
        }); };
        _this.onChange = function (value) {
            config_1.getConfig().validationOn === 'onChange' && _this.setState({ showError: true });
            _this.props.onChange(value);
        };
        _this.onBlur = function (value) {
            config_1.getConfig().validationOn === 'onBlur' && _this.setState({ showError: true });
            _this.setState({ focused: false });
            _this.props.onChange(value);
            _this.props.onBlur && _this.props.onBlur(null);
        };
        _this.onFocus = function () {
            _this.setState({ focused: true });
        };
        _this.dependenciesLoaded = _this.loadDependencies();
        return _this;
    }
    FieldHtml.prototype.componentDidMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var svgPath;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dependenciesLoaded];
                    case 1:
                        svgPath = _a.sent();
                        this.instance = window.jQuery(this.textareaRef.current);
                        this.instance.trumbowyg(tslib_1.__assign({ svgPath: svgPath, useComposition: false, autogrow: true }, config_1.getConfig().trumbowyg.config)).on('tbwfocus', function () {
                            _this.onFocus();
                        }).on('tbwchange', function () {
                            _this.onChange(_this.instance.trumbowyg('html'));
                        }).on('tbwblur', function () {
                            _this.onBlur(_this.instance.trumbowyg('html'));
                        });
                        this.instance.trumbowyg('html', this.props.value);
                        return [2 /*return*/];
                }
            });
        });
    };
    FieldHtml.prototype.componentDidUpdate = function () {
        this.instance.trumbowyg(this.props.disabled ? 'disable' : 'enable');
        if (this.instance.trumbowyg('html') !== this.props.value) {
            this.instance.trumbowyg('html', this.props.value);
        }
    };
    FieldHtml.prototype.render = function () {
        var focused = this.state.focused;
        var _a = this.props, classes = _a.classes, label = _a.label, helperText = _a.helperText, placeholder = _a.placeholder, disabled = _a.disabled;
        return (React.createElement("div", { className: styles.component },
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement("div", { className: classes.label },
                React.createElement(InputLabel_1.default, { error: !!this.errorMessage, required: this.isRequired, focused: focused }, label),
                helperText || this.errorMessage ?
                    React.createElement(Typography_1.default, { variant: 'caption', color: this.errorMessage ? 'error' : 'default' }, this.errorMessage || helperText)
                    : null),
            React.createElement("textarea", { ref: this.textareaRef, placeholder: placeholder, disabled: disabled })));
    };
    FieldHtml = tslib_1.__decorate([
        withStyles_1.WithStyles(function (theme) { return ({
            label: {
                display: 'block',
                marginBottom: 5
            },
            fullWrapper: {
                borderColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.27)' : 'rgba(255, 255, 255, 0.7)',
            },
            editorWrapper: tslib_1.__assign({}, theme.typography.body1)
        }); })
    ], FieldHtml);
    return FieldHtml;
}(FieldCoreBase_1.default));
exports.default = FieldHtml;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Html/index.js
// module id = 486
// module chunks = 58